export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9097.dc68b882.jpg";